'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _reactBootstrap = require('react-bootstrap');

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _auth = require('redux/modules/auth');

var _info = require('redux/modules/info');

var _reduxRouter = require('redux-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Menu1: {
    displayName: 'Menu1'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/Menu/Menu1.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import { Glyphicon } from 'react-bootstrap';

// import { IndexLink } from 'react-router';
// import Helmet from 'react-helmet';
// import { LinkContainer } from 'react-router-bootstrap';
// import { Navbar, NavBrand, Nav, NavItem, CollapsibleNav } from 'react-bootstrap';
//eslint-disable-line
// import { Glyphicon } from 'react-bootstrap';
// import { Window } from '../../components';
// import DocumentMeta from 'react-document-meta';
// import { isLoaded as isInfoLoaded, load as loadInfo } from 'redux/modules/info';
//eslint-disable-line
// import { InfoBar } from 'components';
// import { SidePanel } from 'components';


// import connectData from 'helpers/connectData';

//---------------------------------------------------------
// zobrazeni hamburgeru v menu pred ikonkou uzivatele
//---------------------------------------------------------

var Menu1 = _wrapComponent('Menu1')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data, authState: state.auth };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ pushState: _reduxRouter.pushState, setUiProps: _info.setUiProps, logout: _auth.logout }, dispatch);
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Menu1, _Component);

  function Menu1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Menu1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Menu1.__proto__ || (0, _getPrototypeOf2.default)(Menu1)).call.apply(_ref, [this].concat(args))), _this), _this.handleLogout = function (event) {
      event.preventDefault();
      _this.props.logout();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // constructor() {
  //   super();
  //   this.state = {
  //     xx: false,
  //   };
  // }

  (0, _createClass3.default)(Menu1, [{
    key: 'render',


    // changeOpen = () => {

    //   console.log(this.props.info);
    //   this.props.setUiProps('mainMenuOpened', true);
    //   //const nowState = info.ui[name + 'Display'];
    //   //this.setState({ isOpened: !this.state.isOpened });
    // }
    value: function render() {
      var styles = require('./Menu1.scss');
      var _props = this.props,
          authState = _props.authState,
          info = _props.info,
          setUiProps = _props.setUiProps;
      var user = authState.user,
          loggingIn = authState.loggingIn,
          loginError = authState.loginError; // eslint-disable-line

      var ui = info.ui;

      var isOpened = ui.mainMenuOpened;
      var title = void 0;
      //const caret = loggingIn ? null : <span className="caret"></span>;
      var menuPart = void 0;
      title = _react3.default.createElement(
        'span',
        { className: 'fa fa-navicon' },
        ' '
      );
      //const pp = <span><span className="fa fa-plus-square-o"> </span>&nbsp; Přidat píseň</span>;

      // <ul className="dropdown-menu">
      //  <li><Link to={'/playlists'}>Veřejné playlisty</Link></li>
      //  <li className="divider"></li>
      //  <li>{user ? <Link to={'/create/Song'}>{pp}</Link> : <span style={{color:'gray'}}>&nbsp; {pp} <br/>&nbsp;[Nejste přihlášeni]</span> }</li>

      // </ul>

      menuPart = _react3.default.createElement(
        'li',
        { className: 'dropdown' + (isOpened ? ' open' : ''), onClick: function onClick() {
            return setUiProps('mainMenuOpened', !isOpened);
          } },
        _react3.default.createElement(
          'a',
          { href: '#', className: 'dropdown-toggle', 'data-toggle': 'dropdown', role: 'button', 'aria-haspopup': 'true', 'aria-expanded': 'false' },
          title
        )
      );

      return menuPart;
    }

    // render() {
    //   const {user, loggingIn} = this.props.authState; // eslint-disable-line
    //   // const styles = require('./App.scss');
    //   let title;

    //   let loginPart;
    //   // if (loggingIn) {
    //   //   title = <span className="fa fa-refresh fa-spin"> {' '} </span>;
    //   //   loginPart = (
    //   //            <NavDropdown eventKey={3} id="basic-nav-dropdown" title={title}>
    //   //              <MenuItem eventKey={3.1}>
    //   //                <span className="fa fa-refresh fa-spin"> {' '} </span>
    //   //              </MenuItem>
    //   //           </NavDropdown>);
    //   // } else if (!user) {
    //   if (!user) {
    //     // title = loggingIn ? <span className="fa fa-refresh fa-spin"> {' '} </span> : <span>Příhlásit</span>;
    //     title = <span>Příhlásit</span>;
    //     loginPart = (
    //              <NavDropdown eventKey={3} id="basic-nav-dropdown" title={title} onSelect={() => null}>
    //               <MenuItem eventKey={3.1}>
    //                 <GoogleLogin clientId="280466207305-cfa12qqpekqfkgi21c9rmm7p4afte4ev.apps.googleusercontent.com" />
    //               </MenuItem>
    //               <MenuItem eventKey={3.2} >
    //                 <FacebookLogin appId="226342524229749" />
    //               </MenuItem>
    //               <MenuItem eventKey={3.3} onSelect={this.onNavItemClick} >Something else here</MenuItem>
    //               <MenuItem divider />
    //               <MenuItem eventKey={3.3}>Separated link</MenuItem>
    //             </NavDropdown>);
    //   } else {
    //     title = <UserIco user={user}/>;
    //     loginPart = (
    //         <NavDropdown eventKey={3} id="basic-nav-dropdown" title={title}>
    //               <MenuItem eventKey={3.3} onClick={this.handleLogout} >Odhlásit</MenuItem>
    //         </NavDropdown>);
    //   }


    //   return loginPart;
    // }

  }]);
  return Menu1;
}(_react2.Component), _class2.propTypes = {
  children: _react2.PropTypes.object.isRequired,
  authState: _react2.PropTypes.object,
  logout: _react2.PropTypes.func.isRequired,
  pushState: _react2.PropTypes.func.isRequired,
  setUiProps: _react2.PropTypes.func.isRequired
}, _temp2)) || _class));

// @connect(
//   state => ({authState: state.auth}),
//   {logout, pushState})
exports.default = Menu1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/Menu1.js
// module id = 1185
// module chunks = 0